import { observer } from "mobx-react";
import { ActionProps } from "./Actions";
import React from "react";
import { SuggestionsList } from "../Suggestions/SuggestionsList";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";

export const SelectModelResult = observer(({ args }: ActionProps) => {
    const currentChatStore = useCurrentChatStore();

    if (!("options" in args)) {
        console.warn(
            "Invalid args for SelectModelResult action. Nothing rendered.",
        );
        return null;
    }

    const options = args.options as { result: string; messageToSend: string }[];

    return (
        <SuggestionsList title={args.buttonText ?? "Select model result"}>
            {options.map((option) => (
                <SuggestionsList.ListItem
                    key={option.result}
                    onClick={() => {
                        currentChatStore?.streamingSubmitInput({
                            manualInput: option.messageToSend,
                            suggestion: true,
                        });
                    }}
                >
                    {option.result}
                </SuggestionsList.ListItem>
            ))}
        </SuggestionsList>
    );
});
